module.exports = __webpack_public_path__ + "static/img/1.db1c4e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/1.png
// module id = 4Gx0
// module chunks = 0